async function parseJson(response: Response) {
  return response.json().catch(() => null);
}

function extractErrorMessage(payload: any, fallback: string) {
  return payload?.error?.message || payload?.error || fallback;
}

export async function listModules() {
  const response = await fetch("/api/v1/modules");
  const payload = await parseJson(response);
  if (!response.ok) {
    throw new Error(extractErrorMessage(payload, "Failed to fetch modules"));
  }

  return payload?.data || [];
}
